import { ColumnDef, ColumnHelper } from '@tanstack/react-table'

import { commonAccessorColumn, dateAccessorColumn, moneyAccessorColumn } from '@/components/table'
import { B2CRegistriesRequest } from '@/@types/b2c.types.ts'
import { B2CRegistryTableStatusRenderer } from '@/pages/b2c/components/b2c-registry-table-status-renderer.tsx'

export const KEY_PAGE = 'b2с-registries'

type VisibleColumns =
  | 'id'
  | 'fileName'
  | 'totalCount'
  | 'totalCompletedCount'
  | 'totalSum'
  | 'totalCompletedSum'
  | 'status'
  | 'updateTime'

export type PartialRegistriesRequest = Pick<B2CRegistriesRequest, VisibleColumns>

export const defaultSettings: Record<keyof PartialRegistriesRequest, string> = {
  id: '№ реестра',
  fileName: 'Имя файла',
  totalCount: 'Количество операций',
  totalCompletedCount: 'Количество успешных операций',
  totalSum: 'Сумма списания со счёта',
  totalCompletedSum: 'Сумма списания по успешным операциям',
  status: 'Статус перевода',
  updateTime: 'Дата, время',
}

export function getColumnsSettings(
  columnHelper: ColumnHelper<B2CRegistriesRequest>
): Record<keyof PartialRegistriesRequest, ColumnDef<B2CRegistriesRequest, any>> {
  return {
    id: columnHelper.accessor('id', commonAccessorColumn('№ реестра')),
    fileName: columnHelper.accessor('fileName', commonAccessorColumn('Имя файла')),
    totalCount: columnHelper.accessor('totalCount', {
      id: 'totalCount',
      ...commonAccessorColumn('Количество операций'),
    }),
    totalCompletedCount: columnHelper.accessor('totalCompletedCount', {
      id: 'totalCompletedCount',
      ...commonAccessorColumn('Количество успешных операций'),
    }),
    totalSum: columnHelper.accessor('totalSum', {
      id: 'totalSum',
      ...moneyAccessorColumn('Сумма списания со счёта'),
    }),
    totalCompletedSum: columnHelper.accessor('totalCompletedSum', {
      id: 'totalCompletedSum',
      ...moneyAccessorColumn('Сумма списания по успешным операциям'),
    }),
    status: columnHelper.accessor('status', {
      header: 'Статус перевода',
      cell: (props) => <B2CRegistryTableStatusRenderer value={props.getValue()} />,
    }),
    updateTime: columnHelper.accessor('updateTime', dateAccessorColumn('Дата, время', true, 'Europe/Moscow')),
  }
}
